export const STAFF_ERROR_MSG = 'Error loading staff';
export const DCR_REPORT_FETCH_ERROR_MSG = 'Something went wrong while fetching DCR report!';